import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsCurrencyConverterComponent } from '../cs-currency-converter/cs-currency-converter.component';
import { CsCurrencyUnitDisplayComponent } from '../cs-currency-unit-display/cs-currency-unit-display.component';

@Component({
  selector: 'app-assets-value',
  standalone: true,
  imports: [CommonModule, CsCurrencyConverterComponent, CsCurrencyUnitDisplayComponent],
  templateUrl: './assets-value.component.html',
  styleUrl: './assets-value.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetsValueComponent {
  @Input() value = 0;
  @Input() currentCurrency = 'USDT';
  @Input() currentCurrencyIcon = '';
  @Input() displayInFiat = false;
}
